<template>
  <div v-if="info">
      <div class="p1">
        <div class="logo"  v-if="dayin">
            <img :src="dayin.logo"/>
        </div>
        <div class="title" v-if="dayin">
            <div v-if="!filterFun(info.sys_company_id)">{{dayin.short}}智能中医健康评估报告</div>
            <div v-else>{{filterFun(info.sys_company_id)}}</div>
        </div>
        <div class="time">检测时间：{{info.created_at}}</div>
        <div class="portrait">
            <img :src="user.url" v-if="user.url" />
            <div v-else>
                <img src="../../../../images/user.png" v-if="info.sex==1" />
                <img src="../../../../images/girl.png" v-else />
            </div>
        </div>
        <div class="nikeName">{{user.name?user.name:(user.nikeName?user.nikeName:'')}}</div>
        <ul class="info">
            <li class="flex">
                <div>年龄：</div>
                <div class="flex-1 bottom">
                    {{info.age}}岁
                </div>
            </li>
             <li class="flex">
                <div>性别：</div>
                <div class="flex-1 bottom">
                    {{info.sex==1?'男性':'女性'}}
                </div>
            </li>
            <li class="flex">
                <div>身高：</div>
                <div class="flex-1 bottom">
                    {{info.height}}cm
                </div>
            </li>
            <li class="flex">
                <div>体重：</div>
                <div class="flex-1 bottom">
                    {{info.weight}}kg
                </div>
            </li>
            <li class="flex">
                <div>手机号：</div>
                <div class="flex-1 bottom">
                    {{user.phone?user.phone:''}}
                </div>
            </li>
        </ul>
        <!-- <div class="warning">郑重提醒：本报告不作医学诊断及购药依据之用</div> -->
      </div>
      <div class="p2" v-if="info.test_type!==3">
          <div class="health-box">
            <h1>健康平衡指数</h1>
            <div class="health-grade flex">
                <div class="grade" v-if="0<info.score && info.score<=50">
                    可能患有疾病，建议就医检查
                </div>
                <div class="grade" v-if="50<info.score && info.score<=65">
                    身体极不平衡，建议马上调理
                </div>
                <div class="grade" v-if="65<info.score && info.score<=80">
                    身体较不平衡，建议马上调理
                </div>
                <div class="grade" v-if="80<info.score && info.score<=90">
                    身体较为平衡，建议适当调理
                </div>
                <div class="grade" v-if="90<info.score && info.score<=100">
                    身体平衡，建议适当调理
                </div>
            </div>
          </div>
          <div class="health-box">
            <h1>体重指数（BMI）</h1>
            <div class="health-grade flex">
                <div class="flex-1">我的指数：<span>{{ info.bmi }}</span>{{MBItext}}</div>
                <div>适合的体重：<span>{{ info.suit_weight }}</span>kg</div>
            </div>
            <ul class="thin flex">
                <li>偏瘦：&lt;18.5</li>
                <li>正常：18.5~23.9</li>
                <li>偏胖：24～26.9</li>
                <li>肥胖：27～29.9</li>
                <li>重度肥胖：≥30</li>
            </ul>
          </div>
          <div class="health-box">
            <h1>中医健康状态辨识</h1>
            <div class="health-grade">
                您当前的{{info.report_type==1?'中医证候':'中医体质'}}：<span class="stress">{{info.report_type==1?info.sick_text:info.viscera.tizhi}}</span>
            </div>
          </div>
          <div class="health-box" v-if="info.viscera">
            <h1>{{info.report_type==1?'证候':'体质'}}解析</h1>
            <div class="health-grade" v-if="info.report_type==1">
                <div v-for="( item, index ) in info.sick_text_array" v-bind:key="index">
                    <div v-html="JSON.parse(info.viscera.syndrome_desc)[item]" class="health-html"></div>
                </div>
            </div>
            <div class="health-grade" v-else>
                <div v-html="info.viscera.tizhi_desc" class="health-html"></div>
            </div>
          </div>
          <div v-if="info.report_type==1">
            <div class="health-box" >
                <h1>身体健康状态综合分析</h1>
                <div class="health-grade">
                    <div class="health-html" v-html="info.check_bmi"></div>
                    <div class="health-html" v-html="info.check_estimate" ></div>
                </div>
            </div>
            <div class="health-box" v-if="info.viscera">
                <h1>常见症状</h1>
                <div class="health-grade">
                    <div class="health-html">{{info.viscera.zhengzhuang}}</div>
                </div>
            </div>
            <div class="health-box" v-if="info.viscera">
                <h1>重点预防疾病</h1>
                <div class="health-grade">
                    <div class="health-html">{{info.viscera.yufangjibing}}</div>
                </div>
            </div>
          </div>
          <div class="health-box" v-for="(items, index) in module.data" :key="index">
              <h1>{{items.module_name}}</h1>
              <div class="health-module">
                  <div v-for="( item2, index2 ) in items.description_list" v-bind:key="index2" class="module">
                      <div v-if="item2.list">
                          <span class="orange">{{info.report_type==1?item2.syndrome_name:info.viscera.tizhi}} · </span>
                          <div v-for="( item3, index3 ) in item2.list" v-bind:key="index3" class="moduleins">
                              <div v-for="( item4, index4 ) in item3.module_value" v-bind:key="index4" class="moduleins">
                                  <div class="moduleins">
                                      {{index4==0?item4.value:''}}
                                  </div>
                                  <div v-if="index4!==0">
                                      <div class="moduleins">
                                          {{item4.title}} : {{item4.value}}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { mapState , mapActions } from "vuex";
export default {
    name: 'print',
    props: ["user",'info','MBItext','module','logo','logoName'],
    created:function(){
       this.axioPrint({report_token:this.$route.params.id});
    },
    computed: {
        ...mapState ("report", ["dayin"]),
    },
    methods:{
        filterFun(id){
            let filter = [{
                id:'85',text:'三0二医院中医体质辨识报告'
            }];
            let text = '';
            for(let i=0,n=filter.length;i<n;i++){
                if(filter[i].id==id){
                    text = filter[i].text;
                    break;
                }
            }
            return text;
        },
        ...mapActions ("report", ["axioPrint"])
    }
}
</script>
<style lang="scss" scoped>
  @import './print';
</style>